import { AudioManager } from "../../AudioManager";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { Button } from "../../utils/Utils";
import { MermaidContainer } from "./MermaidContainer";
import { FrameContainer } from "./FrameContainer";
import { TitleContainer } from "./TitleContainer";

export class SplashScene extends Phaser.Scene {

    public static currentInstance: SplashScene;

    private leftFrame: FrameContainer;
    private rightFrame: FrameContainer;
    private audioOnButton: Button;
    private audioOffButton: Button;
    private mermaidContainer: MermaidContainer;
    private f: number;
    private toStartLabel: Phaser.GameObjects.Text;
    private leavingScene: boolean;
    
    constructor() {

        super("SplashScene");
        
        SplashScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        this.f = 0;
        this.leavingScene = false;

        const background = this.add.image(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT * .45, "background");
        background.scaleY = GameVars.scaleY;

        const scaledItemsContainer = this.add.container();
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scaleY = GameVars.scaleY;

        this.mermaidContainer = new MermaidContainer(this);
        this.add.existing(this.mermaidContainer);

        this.leftFrame = new FrameContainer(this, "left");
        this.add.existing(this.leftFrame);

        this.rightFrame = new FrameContainer(this, "right");
        this.add.existing(this.rightFrame);

        const titleContainer = new TitleContainer(this);
        this.add.existing(titleContainer);

        const buttons_py = GameConstants.GAME_HEIGHT / 2 - 320 * GameVars.scaleY;

        this.audioOnButton = new Button(this, 42, buttons_py, "texture_atlas_1", "btn_sound_on_off", "btn_sound_on_on");
        this.audioOnButton.scaleY = GameVars.scaleY;
        this.audioOnButton.onDown(this.onClickAudioButton, this);
        this.add.existing(this.audioOnButton);

        this.audioOffButton = new Button(this, 42, buttons_py, "texture_atlas_1", "btn_sound_off_off", "btn_sound_off_on");
        this.audioOffButton.scaleY = GameVars.scaleY;
        this.audioOffButton.onDown(this.onClickAudioButton, this);
        this.add.existing(this.audioOffButton);
        
        this.audioOnButton.visible = !GameVars.gameData.muted;
        this.audioOffButton.visible = GameVars.gameData.muted;

        let str = this.game.device.os.desktop ? "CLICK ANYWHERE TO START" : "TAP ANYWHERE TO START";

        this.toStartLabel =  this.add.text(GameConstants.GAME_WIDTH / 2,  GameConstants.GAME_HEIGHT - 150 * GameVars.scaleY, str, {fontFamily: "Futura-Medium", fontSize: "30px", color: "#FFFFFF"});
        this.toStartLabel.setShadow(1.5, 1.5, "#000000", 5);
        this.toStartLabel.setOrigin(.5);
        this.toStartLabel.scaleY = GameVars.scaleY;

        this.tweens.add({
            targets: this.toStartLabel,
            alpha: .65,
            scaleX: .985,
            scaleY: .985 * GameVars.scaleY,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 900,
            yoyo: true,
            repeat: -1
        });

        this.input.on("pointerup", this.onClickPlay, this);

        AudioManager.playSound("templok_soundtrack", true);
    }

    public update(): void {

        this.f ++;

        this.leftFrame.update();
        this.rightFrame.update();
    }

    private onClickAudioButton(): void {

        AudioManager.toggleAudioState();

        this.audioOnButton.visible = !GameVars.gameData.muted;
        this.audioOffButton.visible = GameVars.gameData.muted;

        AudioManager.playSound("btn_feature_pressed");
    }

    private onClickPlay(): void {

        if (this.leavingScene || this.f < 20) {
            return;
        }

        const x = this.input.activePointer.x;
        const y = this.input.activePointer.y;

        if (x > this.audioOffButton.x - 40 && x < this.audioOffButton.x + 40 && y > this.audioOffButton.y - 40 * GameVars.scaleY && y < this.audioOffButton.y + 40 * GameVars.scaleY) {
            return;
        }

        this.leavingScene = true;

        this.toStartLabel.visible = false;

        const loadIcon = this.add.image(this.toStartLabel.x, this.toStartLabel.y, "texture_atlas_1", "load_icon");
        loadIcon.scaleY = GameVars.scaleY;

        this.tweens.add({
            targets: loadIcon,
            angle: 360,
            ease: Phaser.Math.Easing.Linear,
            duration: 2000,
            repeat: -1
        });

        GameManager.enterBoardScene();
    
        AudioManager.playSound("btn_feature_pressed");
    }
}
